import { fabric } from 'fabric-with-gestures';

// Uploaded artwork is almost always much larger than the print area it is dropped
// into: a 3000px logo in a 300px bounding box renders at scale 0.1. Fabric's
// default is a single drawImage step at that scale, which samples only a fraction
// of the source pixels. Fine detail - thin lines, small type - falls apart, so a
// perfectly good file previews as soft. Customers read that as "my file is not
// sharp" and raise it in the design notes, while the file itself is untouched:
// the upload is stored as-is and the preview scale is the only thing degrading it.
//
// resizeFilter is fabric's built-in answer. It resamples the source properly
// (hermite, a weighted-area filter that reads every source pixel) before drawing,
// which is why a correctly downscaled image looks slightly blurrier than the
// original at 100% yet visibly sharper at preview size.
//
// The cost is bounded by fabric itself:
//  - _render skips it while an object is being dragged (isMoving), so no drag lag;
//  - the result is cached until the scale actually changes (_needsResize).
//
// Set on the prototype so every image is covered - editor, side thumbnails and the
// export renderer all create their own fabric.Image instances. Fabric copies
// filter.scaleX/scaleY onto the filter right before a synchronous apply, so one
// shared instance across objects is safe.
export default function enableHighQualityDownscaling() {
	if (fabric.Image.prototype.resizeFilter) return;
	fabric.Image.prototype.resizeFilter = new fabric.Image.filters.Resize({ resizeType: 'hermite' });

	// Fabric's default threshold of 0.5 is measured on getTotalObjectScaling(),
	// which multiplies the object scale by canvas zoom AND devicePixelRatio. On a
	// retina screen an image at a quarter scale reports 0.25 * 2 = 0.5, landing
	// exactly on the threshold - and anything between a quarter and full size is
	// skipped entirely, which is the range customers actually work in. Resample
	// whenever the image is drawn below 1:1 instead.
	//
	// Not exactly 1: at an untouched 1:1 on a non-retina screen that would run a
	// pointless same-size resample on every image.
	fabric.Image.prototype.minimumScaleTrigger = 0.5;
}
